// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"af73f14c","513":"62a40e53","703":"85fad154","787":"36fe93a4"}[chunkId] + ".chunk.js";
};